import React, { useMemo } from 'react';
import { FolderTileProps } from '../types';
import FolderTileLayout from './FolderTileLayout';
import FolderStoryLayout from './FolderStoryLayout';
import FolderEditableCard from './FolderEditableCard';
import FolderTileWrapper from './FolderTileWrapper';
import { useFolderLayoutActions } from './useFolderLayoutActions';

const RoomFolderLayout: React.FC<FolderTileProps> = ({
  id,
  name: initialName,
  itemCount = 0,
  coverSigned,
  onClick,
  isTiles = true,
  isEditMode = false,
  thumbnailHeight,
  onRename,
  onDelete,
}) => {
  const {
    displayName,
    isRenameDialogOpen,
    isDeleteDialogOpen,
    isDeleting,
    handleRenameClick,
    handleRenameClose,
    handleRenameSuccess,
    handleDeleteClick,
    handleDeleteClose,
    handleDeleteConfirm,
  } = useFolderLayoutActions({ id, initialName, onRename, onDelete });

  const LayoutComponent = useMemo(
    () => (isTiles ? FolderTileLayout : FolderStoryLayout),
    [isTiles]
  );

  const layoutProps = useMemo(
    () => ({
      id,
      name: displayName,
      itemCount,
      coverSigned,
      onClick,
      thumbnailHeight,
    }),
    [id, displayName, itemCount, coverSigned, onClick, thumbnailHeight]
  );

  const sharedDialogProps = {
    displayName: displayName || '',
    isRenameDialogOpen,
    isDeleteDialogOpen,
    isDeleting,
    onRenameClick: handleRenameClick,
    onRenameClose: handleRenameClose,
    onRenameSuccess: handleRenameSuccess,
    onDeleteClick: handleDeleteClick,
    onDeleteClose: handleDeleteClose,
    onDeleteConfirm: handleDeleteConfirm,
  };

  if (isEditMode && !isTiles) {
    return (
      <FolderEditableCard {...sharedDialogProps}>
        <LayoutComponent {...layoutProps} />
      </FolderEditableCard>
    );
  }

  return (
    <FolderTileWrapper isEditMode={isEditMode} {...sharedDialogProps}>
      <LayoutComponent {...layoutProps} />
    </FolderTileWrapper>
  );
};

export default React.memo(RoomFolderLayout);
